/** Config dos banners — ajustes via PR (sem .env). */
export const USABILITY_SURVEY_BASE_URL =
  'https://v3.app-indecx.com/survey-link/69c414260691950034fa55e0';
export const BRAND_SURVEY_URL =
  'https://brand.indecx.com.br/survey?id=fb567272-c3db-4bf3-aba3-a2fc9d4e99ed&src=two_&utm_source=Portal&utm_medium=Portal+Granel&utm_campaign=Brandscore&utm_content=B2B';
export const WHATSAPP_OFFICIAL_PHONE = '11933058481';
